const STORAGE_PREFIX = 'cognidoor_attr_';
const KEY_FIRST_TOUCH = `${STORAGE_PREFIX}first_touch`;
const KEY_LAST_TOUCH = `${STORAGE_PREFIX}last_touch`;
const KEY_SESSION = `${STORAGE_PREFIX}session`;
const KEY_FIRST_LANDING = `${STORAGE_PREFIX}first_landing_page`;

function safeParse(json) {
  if (!json) return null;
  try {
    return JSON.parse(json);
  } catch {
    return null;
  }
}

function safeSet(storage, key, value) {
  try {
    storage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

function safeGet(storage, key) {
  try {
    return safeParse(storage.getItem(key));
  } catch {
    return null;
  }
}

export function readFirstTouch() {
  return safeGet(localStorage, KEY_FIRST_TOUCH);
}

export function readLastTouch() {
  return safeGet(localStorage, KEY_LAST_TOUCH);
}

export function readSessionTouch() {
  return safeGet(sessionStorage, KEY_SESSION);
}

export function readFirstLandingPage() {
  try {
    return localStorage.getItem(KEY_FIRST_LANDING) || null;
  } catch {
    return null;
  }
}

export function writeFirstTouch(touch) {
  if (!touch) return;
  if (readFirstTouch()) return;
  safeSet(localStorage, KEY_FIRST_TOUCH, touch);
  if (touch.landing_page) {
    try {
      localStorage.setItem(KEY_FIRST_LANDING, touch.landing_page);
    } catch {
      // ignore
    }
  }
}

export function writeLastTouch(touch) {
  if (!touch) return;
  safeSet(localStorage, KEY_LAST_TOUCH, touch);
}

export function writeSessionTouch(touch) {
  if (!touch) return;
  safeSet(sessionStorage, KEY_SESSION, touch);
}

export const PURCHASE_SENT_PREFIX = 'cognidoor_purchase_sent_';

export function isPurchaseEventSent(orderId) {
  if (!orderId) return false;
  try {
    return localStorage.getItem(`${PURCHASE_SENT_PREFIX}${orderId}`) === '1';
  } catch {
    return false;
  }
}

export function markPurchaseEventSent(orderId) {
  if (!orderId) return;
  try {
    localStorage.setItem(`${PURCHASE_SENT_PREFIX}${orderId}`, '1');
  } catch {
    // ignore
  }
}
